export default {"src":"/_next/static/media/icon_play_live.4bb50b83.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};